import type { EF } from "@portal/@types/everflow";
import { EVERFLOW_PARAMETER_DEFINITIONS } from "@portal/app/_common/lib/everflowParameters";
import { getSafeUrlParam } from "@portal/app/_common/lib/urlParamUtils";
import { EVERFLOW_OFFER_ID } from "@portal/app/_common/types/everflow";

export type EverflowClickOptions = Parameters<EF["click"]>[0];

/** SDK payload construction is independent of the decision to create a click. */
export function buildEverflowClickOptions(url: URL, referrer: string): EverflowClickOptions {
  const options: EverflowClickOptions = {};
  const parameters: Record<string, string> = {};
  let platform = "";
  for (const [key, definition] of Object.entries(EVERFLOW_PARAMETER_DEFINITIONS)) {
    const value = getSafeUrlParam(key, url.search);
    if (!value) continue;
    if (definition.sdkOption === "parameters") parameters[key] = value;
    else if (definition.sdkOption) options[definition.sdkOption] = value;
    if ("platform" in definition) {
      platform =
        typeof definition.platform === "function"
          ? definition.platform(value)
          : definition.platform;
    }
  }

  const organic = !options.offer_id && !options.affiliate_id;
  // Preserve SDK organic defaults without its live-URL fallback, which can
  // replace the options object after navigation has changed the landing URL.
  return {
    ...options,
    offer_id: options.offer_id || EVERFLOW_OFFER_ID,
    affiliate_id: options.affiliate_id || 3,
    sub1: options.sub1 || (organic ? platform : undefined),
    sub2: options.sub2 || (organic ? referrer : undefined),
    sub3: options.sub3 || (organic ? "/" + url.pathname.split("/")[1] : undefined),
    sub4: options.sub4 || (organic ? url.pathname : undefined),
    sub5: options.sub5 || (organic ? url.search : undefined),
    source_id: options.source_id || (organic ? "organic" : undefined),
    ...(organic && { organic: 1 }),
    landing_url: url.href,
    parameters,
  };
}
